// src/cache/exchange-rate.cache.ts

import { getRedisClient } from '../../client';
import { getKey } from '../../utils/redisKeys';

const prefix = 'exchangeRate';

/**
 * تخزين سعر التحويل بين عملتين
 */
export async function setExchangeRate({ from, to, rate, ttlInSec }: { from: string; to: string; rate: number; ttlInSec?: number }): Promise<void> {
  const client = getRedisClient();
  const key = getKey({ prefix, id: `${from}_${to}` });
  const value = rate.toString();

  if (ttlInSec) {
    await client.set(key, value, { EX: ttlInSec });
  } else {
    await client.set(key, value);
  }
}

/**
 * جلب سعر التحويل من كاش Redis
 */
export async function getExchangeRate(from: string, to: string): Promise<number | null> {
  const client = getRedisClient();
  const key = getKey({ prefix, id: `${from}_${to}` });
  const data = await client.get(key);
  return data ? parseFloat(data) : null;
}

/**
 * حذف سعر تحويل عملتين من الكاش
 */
export async function deleteExchangeRate(from: string, to: string): Promise<void> {
  const client = getRedisClient();
  const key = getKey({ prefix, id: `${from}_${to}` });
  await client.del(key);
}

/**
 * جلب أكثر من سعر تحويل دفعة واحدة
 */
export async function getExchangeRatesBulk(pairs: { from: string; to: string }[]): Promise<(number | null)[]> {
  const client = getRedisClient();
  const keys = pairs.map(({ from, to }) => getKey({ prefix, id: `${from}_${to}` }));
  const results = await client.mGet(keys);
  return results.map(val => (val ? parseFloat(val) : null));
}
